export default __webpack_public_path__ + "static/media/cgk_logo_new.7324aa93.png";